import { GET_NDHM_HOST } from "../../constants/env";
import { AxonGenericApiResponse } from "../../types/axon";
import fetch from "../../fetch-client";

export default async function postHprAadhaarMobileVerify({
  doctor_oid,
  txn_id,
  mobile_num,
}: {
  doctor_oid: string;
  txn_id: string;
  mobile_num: string;
}): Promise<
  AxonGenericApiResponse<{
    verified: boolean;
    hpr?: {
      hprId: string;
    };
    suggested_hpr_ids?: Array<string>;
  }>
> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ txn_id, mobile_num });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/demo/verify?doctor_oid=${doctor_oid}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
